import userSWR from 'swr';

import { fetcher } from '../utils/fetcher';
import { useGetShortCode } from './useGetShortCode';

export const useFetchAchievements = (filter) => {
    const shortCode = useGetShortCode();

    const fields = [
        '*',
        'translations.*',
        'points.*',
        'contests.*',
        'beef_product.*',
        'beef_product.translations.*',
    ];

    const deep = {
        points: {
            _filter: {
                short_code: {
                    _eq: shortCode
                }
            }
        },
    };

    const { data: data, error, isLoading } = userSWR(filter ? {
        url: 'achievements',
        deep,
        fields,
        filter,
        // sort: 'contests.sort'
    } : null, fetcher);

    const achievements = data?.map(achievement => {
        return {
            ...achievement,
            points: achievement.points.reduce((accumulator, current) => {
                return accumulator + current.points;
            }, 0),
        }
    }).sort((a, b) => {
        const aSort = a.contests?.[0]?.sort || 0;
        const bSort = b.contests?.[0]?.sort || 0;
        return aSort - bSort;
    });

    return {
        data: achievements,
        error,
        isLoading,
    };
};